import { react, useState } from "react";
import { Mask, SpinLoading } from 'antd-mobile'
import styles from './Loading.module.css'

export default (props) => {
  // const [visible, setVisible] = useState(props.visible)
  const visible =props.visible
  return (<div>
    <Mask visible={visible}>
      <div className={styles.overlayContent}>
        <SpinLoading style={{ '--size': '64px' }} />
      </div>
    </Mask>
  </div>)
}